import { IAddress } from '@/domains/ProfileDomain'

import { call } from '../core'

export interface IRequestAddressInfo {
  checkAvailableDelivery?: boolean
}

export interface IAddressInfoResult {
  result: IAddress | null
}

export function getAddress(params: IRequestAddressInfo): Promise<IAddressInfoResult | Error> {
  return call('finGetAddress', params)
}
